import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Outbound links to our own affiliated platform (Simplestores) are marked
// rel="sponsored". Links to every other (competitor) platform are marked
// rel="nofollow" so we don't pass SEO authority to sites we're comparing.
export function outboundRel(platform) {
  const slug = typeof platform === "string" ? platform : platform?.slug;
  return slug === "simplestores" ? "sponsored noopener noreferrer" : "nofollow noopener noreferrer";
}
